"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVISION_SUGGESTION_NAMES = exports.RevisionSuggestion = exports.RevisionSuggester = void 0;
const object_1 = require("../../util/object");
const suggestion_1 = require("../suggestion");
const suggester_1 = require("./suggester");
class RevisionSuggester extends suggester_1.Suggester {
    constructor(text, ignoreOptions) {
        super(text, ignoreOptions);
    }
    prepare() {
    }
    presuggest(dictionary) {
        const revisions = dictionary.settings.revisions;
        const names = revisions.resolve(this.text, this.ignoreOptions);
        if (names.length > 0) {
            const suggestion = new RevisionSuggestion(names);
            return [suggestion];
        }
        else {
            return [];
        }
    }
    suggest(word, dictionary) {
        return [];
    }
}
exports.RevisionSuggester = RevisionSuggester;
class RevisionSuggestion extends suggestion_1.Suggestion {
    constructor(names) {
        super("revision", [], names);
    }
    getKindName(language) {
        return object_1.ObjectUtil.get(exports.REVISION_SUGGESTION_NAMES, language);
    }
    getDescriptionName(kind, type, language) {
        return undefined;
    }
}
exports.RevisionSuggestion = RevisionSuggestion;
exports.REVISION_SUGGESTION_NAMES = { ja: "綴り改定", en: "Spelling revision" };
